import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'la-more-button',
  templateUrl: './more-button.component.html',
  styleUrl: './more-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatButtonModule, MatIconModule, RouterModule],
})
export class MoreButtonComponent {
  @Input() buttonLink?: string[] | string | null | undefined;

  @Output() action = new EventEmitter<void>();
}
